<template>
    <div class="popup popup-full popup-ord-dtl active" id="popup-ord-dtl">
        <div id="wrap">
            <header class="replboxHead">
                <div class="btn_back hidden">
                    <a class="button"> </a>
                </div> 
                <h1>주문/발송 상세</h1>
                <div class="menu_side">
                    <a class="btn_detail_close" @click="$go(-1)">
                        <i class="xi-close"></i>
                    </a>
                </div>
            </header>

            <section class="order_detail" v-show="goodsList!=undefined && goodsList.length > 0">
                <div class="order_detail_wrap" id="top">
                    <h5 class="payment_status">{{ord.dlv}}</h5>
                    <dl class="payment_result"> <dt>주문번호</dt><dd>{{this.odOrdMst.ord_no}}</dd> </dl>
                    <dl class="payment_result"> <dt>주문일</dt><dd>{{ord.ord_dtime}}</dd> </dl>
                </div>

                <div class="order_detail_wrap">
                    <ul class="inquiry product_payment_list">
                        <li v-for="good in goodsList" :key="good.good_no">        
                            <div class="thumb">
                                <img :src="$store.getters['systemStore/getImgPath']+good.good_img_url" :alt="good.good_nm">
                            </div>
                            <div class="info">
                                <p class="product_name">{{good.good_nm}}</p>
                                <!-- <p class="product_name">{{good.disp_good_nm}}</p> -->
                                <!-- <span class="ea">{{good.ord_qty}}개</span> -->
                                <!-- <strong class="price">{{good.sale_price.toLocaleString()}}원   X  {{good.real_ord_qty.toLocaleString()}}개</strong> -->
                                <strong class="price">{{good.sale_price.toLocaleString()}}원   X  {{good.real_ord_qty}}개</strong>
                            </div>
                        </li>
                    </ul> 
                </div>

                <!-- S: 주문자 정보 -->
                <div class="order_detail_wrap">
                    <h5>주문자 정보</h5>
                    <dl class="payment_result"> <dt>주문자</dt> <dd>{{odOrdMst.orderer_nm}}</dd> </dl>
                    <dl class="payment_result"> <dt>휴대폰 번호</dt> <dd>{{odOrdMst.cell_no_1}}-{{odOrdMst.cell_no_2}}-{{odOrdMst.cell_no_3}}</dd> </dl>
                    <dl class="payment_result"> <dt style="width:auto;">이메일</dt> <dd style="width:auto;">{{odOrdMst.email}}</dd> </dl>
                </div>
                <!-- E: 주문자 정보 -->

                <!-- S: 결제 정보 -->
                <div class="order_detail_wrap">
                    <h5>결제 정보</h5>
                    <dl class="payment_result"> <dt>결제 방법</dt> <dd>{{pay_mean}}</dd> </dl>
                    <!-- <dl class="payment_result"> <dt>총 상품금액</dt> <dd>{{cost_list.GOOD_TOTAL_AMT.toLocaleString()}}원</dd> </dl> -->
                    <!-- <dl class="payment_result"> <dt>할인 금액</dt> <dd>0원</dd> </dl> -->
                    <!-- <dl class="payment_result"> <dt>배송비</dt> <dd>2,500원</dd> </dl> -->


                    <!-- 6,000원 -->
                    <dl v-if="odOrdMst.ord_no === '202112210989319' || odOrdMst.ord_no === '202112210984031' || odOrdMst.ord_no === '202112200978777' || odOrdMst.ord_no === '202112200970529' || odOrdMst.ord_no === '202112200967802' ||
                              odOrdMst.ord_no === '202112170936682' || odOrdMst.ord_no === '202112170941106' || odOrdMst.ord_no === '202112200965776' || odOrdMst.ord_no === '202112200966743'" class="payment_result final"> 
                        <!-- <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.GOOD_TOTAL_AMT.toLocaleString()}}원</dd>  -->
                        <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd> 
                        <dt>총 할인금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">6,000원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">0원</dd> 
                    </dl>

                    <!-- 12,000원 -->
                    <dl v-else-if="odOrdMst.ord_no === '202112200968077' || odOrdMst.ord_no === '202112170931027'" class="payment_result final"> 
                        <!-- <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.GOOD_TOTAL_AMT.toLocaleString()}}원</dd>  -->
                        <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd>  
                        <!-- <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd>  -->
                        <dt>총 할인금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">6,000원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">6,000원</dd> 
                    </dl>

                    <!-- 402,000원 -->
                    <dl v-else-if="odOrdMst.ord_no === '202112170939564'" class="payment_result final">
                        <!-- <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.GOOD_TOTAL_AMT.toLocaleString()}}원</dd>  -->
                        <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd>  
                        <!-- <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd>  -->
                        <dt>총 할인금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">67,000원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">335,000원</dd> 
                    </dl>

                    <!-- 135,000-->
                    <dl v-else-if="odOrdMst.ord_no === '202112200967916'" class="payment_result final">  
                        <!-- <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.GOOD_TOTAL_AMT.toLocaleString()}}원</dd>  -->
                        <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <!-- <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd>  -->
                        <dt>총 할인금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">15,000원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">120,000원</dd> 
                    </dl>

                    <dl v-else class="payment_result final"> 
                        <!-- <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.GOOD_TOTAL_AMT.toLocaleString()}}원</dd>  -->
                        <dt>최초결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.FIRST_TOTAL_AMT.toLocaleString()}}원</dd> 
                        <dt>환불(부분취소)금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.RE_AMT.toLocaleString()}}원</dd> 
                        <dt>총 결제금액</dt> <dd :class="{'cancel':ord.dlv==='결제취소'}">{{cost.GOOD_TOTAL_AMT.toLocaleString()}}원</dd> 
                    </dl>
                    
                </div>
                
                <!-- E: 주문자 정보 -->

                <div class="order_detail_wrap" v-if="deposit">
                    <h5>무통장 상세 정보</h5>
                    <dl class="payment_result"> <dt>입금 계좌번호</dt> <dd> {{this.bank_cd}} {{this.account_no}} </dd> </dl>
                    <dl class="payment_result"> <dt>예금주</dt> <dd> 삼성웰스토리㈜ </dd> </dl>
                    <dl class="payment_result"> <dt>입금인</dt> <dd> {{this.morc_nm}} </dd> </dl>
                    <dl class="payment_result"> <dt>입금금액</dt> <dd> {{this.pay_amt}}원 </dd> </dl>
                    <dl class="payment_result"> <dt>입금기한</dt> <dd> {{this.expiry_date}} </dd> </dl>
                </div>
                
                <div class="order_detail_wrap"
                    v-if="(ord.dlv === '상품준비중') ||
                          (ord.dlv != '결제취소' && giftishow_yn==='Y' && giftishow_cancel_poss_yn === 'Y')">
                    <button class="btn_large" @click="allCancle()">전체주문취소</button>
                </div>

                <div class="order_detail_wrap txt-center">
                    <p class="support">고객지원 <strong class="txt_blue"><a :href="'tel:'+$store.getters['systemStore/getTel']">{{$store.getters['systemStore/getTel']}}</a></strong></p>
                    <div class="use_time">
						<span>평일 09:00 - 18:00</span><br/>
						<span>주말 및 공휴일 휴무</span><br/>
						<span>점심시간 12:00 - 13:00</span><br/>
					</div>
                </div>
                <Footer/>
            </section>
        </div>

        <!-- alert -->
        <div class="popup ord_dtl_01">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                    <p>주문이 취소되었습니다.</p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" @click="$go(-1)">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>
        <div class="popup ord_dtl_02">
            <div class="popup_container">
                <header class="popup_header">안 내</header>
                <div class="popup_content">
                   <p v-html="alertMsg"></p>
                </div>
                <div class="popup_button">
                    <button class="btn_large" onclick="modal('ord_dtl_02')">확 인</button>
                </div>
                
            </div>
            <div class="dimBg"></div>
        </div>

    </div>
</template>

<script>
import {api} from '@/api/index'
import Footer from '@/components/MainFooter'
export default {
    data() {
        return {
            isPossAllCncl: true,
            ord: {},
            goodsList: undefined,
            odOrdMst:[],
            payList:[{card_nm:''}],
            cost: {GOOD_TOTAL_AMT: 0,
                    FIRST_TOTAL_AMT: 0,    
                    RE_AMT: 0
                    },

            //무통장
            deposit: false,
            pay_mean : "",
            account_no : "",
            morc_nm : "",
            pay_amt : "",
            expiry_date : "",
            bank_cd: "",
            alertMsg : "",
            giftishow_yn : "N",
            giftishow_cancel_poss_yn : "N"
        }
    },
    watch: {
        $route() {
            let hash = this.$route.hash;
            console.log(hash)
            if(hash === '') {
                this.$go();
            }
            
        }
    },
    computed: {
        //전체 주문 취소 가능 여부
        filteringGoodsList() {

            // for(let ord in this.g)

            return this.goodsList
        }
    },
    methods: {
        allCancle(){
            if(confirm('해당 주문을 취소하시면 수신자에게 선물이 배송되지 않습니다. 주문을 취소하시겠습니까?')) {
                api.postAsync('/replboxifs/registOrdAllCancle.do',{ord_no: this.odOrdMst.ord_no})
                    .then(data=> {
                        if(data.status === "FAIL") {
                            this.fnAlert("이미 등록한 배송지가 존재합니다. 주문 취소가 불가능합니다.");
                            // $('.ord_dtl_02').addClass('active');
                            return;
                        }
                        if(data.status === "BO_FAIL") {
                            this.fnAlert("법인 승인이 완료되었습니다. 주문 취소가 불가능합니다.");
                            // $('.ord_dtl_02').addClass('active');
                            return;
                        }
                        if(data.status === "fail") {
                            this.fnAlert(data.msg);
                            // $('.ord_dtl_02').addClass('active');
                            return;
                        }
                        console.log(data);
                        console.log(data.status);
                        // status fail 일때만 msg
                        console.log(data.msg);
                        $('.ord_dtl_01').addClass('active');
                });
            }
        },
        fnAlert(msg) {
            this.alertMsg = msg;
            $('.ord_dtl_02').addClass('active');
        }
    },


    async created() {
        this.ord.ord_no = this.$route.query.ord_no;
        this.ord.event_no = this.$route.query.event_no;
        this.ord.dlv = this.$route.query.dlv;
        this.ord.ord_dtime = this.$route.query.ord_dtime;
        this.ord.pageName = "OrderDtl";
        await api.postAsync('/replboxifs/initOrderFinish.do', this.ord)
                .then(data=> {
                    this.goodsList = data.good_list_ord_dtl;
                    this.odOrdMst = data.odOrdMst;
                    this.payList = data.pay_list;
                    this.cost = data.cost_list;
                    this.giftishow_yn = data.giftishow_yn;
                    this.giftishow_cancel_poss_yn = data.giftishow_cancel_poss_yn;
                    console.log(data);
                // 결제방법
                for(let pay of this.payList){
                    if(pay.pay_mean_cd === "11"){
                        this.pay_mean = "신용카드 (" + pay.card_nm + ")";
                        if(pay.card_nm === null){
                            this.pay_mean = "신용카드";
                        }
                    }
                    if(pay.pay_mean_cd === "13"){
                        this.deposit = true;
                        this.pay_mean = "무통장입금";
                        this.account_no = pay.account_no;
                        this.morc_nm = pay.morc_nm;
                        // this.pay_amt = (pay.pay_amt*1).toLocaleString();
                        this.pay_amt = pay.pay_amt
                        this.expiry_date = pay.expiry_date.substring(0,4) + "-" + pay.expiry_date.substring(4,6) + "-" + pay.expiry_date.substring(6,8);

                        var bank_c = Number(pay.bank_cd);
                        for(let usable of data.usableList){
                            if(usable.settle_cd === '13'){
                                var settle_dtl_cd = Number(usable.settle_dtl_cd);
                                if(bank_c == settle_dtl_cd){
                                    this.bank_cd = usable.settle_dtl_nm;
                                }
                            }
                        }

                        // 무통장입금 이벤트페이지 결제완료처리
                        api.postAsync('/replboxifs/updateOrderNo.do',{
                            ord_no: this.ord.ord_no,
                            event_no: this.ord.event_no
                        });
                    }

                }
            })
        },
        components:{Footer}
}
</script>
<style scoped>
.payment_result.final .cancel {text-decoration:line-through; color: var(--text-sub-color);}
</style>